import { db } from "@/plugins/firebase";

export default () => {
  function getOnSnapshotSubscriptionFunction(onUpdate) {
    return snapshot => {
      const newData = [];

      snapshot.docs.forEach(doc => {
        const data = doc.data();
        newData.push({ id: doc.id, data: data });
      });
      onUpdate(newData);
    };
  }

  // A comma separated string of ballots
  // ballots: row[0]

  // Weights
  // weights: 1

  // SSN for the delegate
  // ssn: row[1]

  // Manually set name
  // manual-name: row[2]

  // Phone number
  // phone: row[3]

  // Email
  // email: row[4]
  return {
    preregistration: (preregistrationId, onUpdate) => {
      console.log(
        "Starting subscription on preregistration: " + preregistrationId
      );
      return db
        .collection("preregistrations")
        .doc(preregistrationId)
        .onSnapshot(doc => onUpdate({ id: doc.id, data: doc.data() }));
    },
    attendents: (preregistrationId, onUpdate) => {
      console.log(
        "Starting subscription on attendents for: " + preregistrationId
      );
      return db
        .collection("preregistrations")
        .doc(preregistrationId)
        .collection("attendents")
        .onSnapshot(getOnSnapshotSubscriptionFunction(onUpdate));
    },
    updatePreregistration: async (preregistrationId, id, member) => {
      await db
        .collection("preregistrations")
        .doc(preregistrationId)
        .collection("attendents")
        .doc(id)
        .set(member, { merge: true });
    }
  };
};
